import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getStatusNotificationUserTypes = createAsyncThunk(
  '/getStatuslNotifications',
  async (data) => {
    const response = await axiosHeadOffice.get(`/HeadOffice/getStatuslNotifications/${data.Id}/${data.TypeId}`);
    return response.data;
  }
);

export const getSpecialNotificationUserTypes = createAsyncThunk(
  '/getSpecialNotifications',
  async (data) => {
    const response = await axiosHeadOffice.get(`/HeadOffice/getSpecialNotifications/${data.Id}/${data.TypeId}`);
    return response.data;
  }
);

export const getSlaNotificationUserTypes = createAsyncThunk(
  '/getSlaNotifications',
  async (data) => {
    const response = await axiosHeadOffice.get(`/HeadOffice/getSlaNotifications/${data.Id}/${data.TypeId}`);
    return response.data;
  }
);

export const setInternalNotificationUserTypes = createAsyncThunk(
  '/setStatusNotifications',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/setStatusNotifications',
      data
    );
    return response.data;
  }
);

export const setSpecialNotifications = createAsyncThunk(
  '/setSpecialNotifications',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/setSpecialNotifications',
      data
    );
    return response.data;
  }
);

export const setSlaNotifications = createAsyncThunk(
  '/setSlaNotifications',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/setSlaNotifications',
      data
    );
    return response.data;
  }
);

const NotificationCenterInternalNotificationSlice = createSlice({
  name: 'NotificationCenterInternalNotificationSlice',
  initialState: {
    loading: false,
    error: '',
    success: false,
    StatusNotificationData: [],
    SpecialNotificationData:[],
    SlaNotificationData:[]
  },
  reducers: {
  },
  extraReducers: {
    [getStatusNotificationUserTypes.pending]: state => {
      state.loading = true;
    },
    [getStatusNotificationUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getStatusNotificationUserTypes.fulfilled]: (state, action) => {
      state.StatusNotificationData = action.payload;
      state.loading = false;
    },
    [getSpecialNotificationUserTypes.pending]: state => {
      state.loading = true;
    },
    [getSpecialNotificationUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSpecialNotificationUserTypes.fulfilled]: (state, action) => {
      state.SpecialNotificationData = action.payload;
      state.loading = false;
    },
    [setInternalNotificationUserTypes.pending]: state => {
      state.loading = true;
    },
    [setInternalNotificationUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setInternalNotificationUserTypes.fulfilled]: (state, action) => {
      state.StatusMailUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setSpecialNotifications.pending]: state => {
      state.loading = true;
    },
    [setSpecialNotifications.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setSpecialNotifications.fulfilled]: (state, action) => {
      state.StatusMailUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setSlaNotifications.pending]: state => {
      state.loading = true;
    },
    [setSlaNotifications.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setSlaNotifications.fulfilled]: (state, action) => {
      state.StatusMailUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [getSlaNotificationUserTypes.pending]: state => {
      state.loading = true;
    },
    [getSlaNotificationUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSlaNotificationUserTypes.fulfilled]: (state, action) => {
      state.SlaNotificationData = action.payload;
      state.loading = false;
    },
  }
});

export const StatusManagementActions = NotificationCenterInternalNotificationSlice.actions;

export default NotificationCenterInternalNotificationSlice;
